module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d44a4ea3b3b168cf5212ee949f4f33d1.png";